import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-sidebar-portal',
  templateUrl: './menu-sidebar-portal.component.html',
  styleUrls: ['./menu-sidebar-portal.component.scss']
})
export class MenuSidebarPortalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
